import axios from 'axios';

export const equipmentBrandApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/equipment-brand`,
    headers: {
        'Content-Type': 'application/json'
    }
})